import { Upload } from "lucide-react";

export default function PhotoPlaceholder({ label, className = "", uploadable = false, sublabel }) {
  return (
    <div
      className={`relative flex h-full w-full flex-col items-center justify-center overflow-hidden bg-navy ${className}`}
      data-testid="photo-placeholder"
    >
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: "radial-gradient(rgba(255,255,255,0.10) 1px, transparent 1px)",
          backgroundSize: "22px 22px",
        }}
      />
      <span className="absolute left-3 top-3 flex h-6 w-6 items-center justify-center rounded-md bg-brandblue">
        <span className="block h-2.5 w-2.5 rounded-full bg-white" />
      </span>
      <p className="relative z-10 px-6 text-center font-mono text-[11px] tracking-[0.22em] text-white/70">
        {label}
      </p>
      {uploadable ? (
        <div
          className="relative z-10 mt-3 inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/5 px-3 py-1.5 font-mono text-[10px] tracking-[0.18em] text-white/80 backdrop-blur-sm"
          data-testid="photo-placeholder-upload"
        >
          <Upload className="h-3 w-3" />
          BROWSE FILES
        </div>
      ) : (
        <p className="relative z-10 mt-2 font-mono text-[9px] tracking-[0.22em] text-white/40">
          {sublabel || "PHOTO COMING SOON"}
        </p>
      )}
    </div>
  );
}
